import { profileHandlers } from './profile'

export const handlers = [...profileHandlers]
